import CockpitNotificationModelBase from '../_generated/modelBases/cockpit-notification-model-base';

export default class CockpitNotificationModel extends CockpitNotificationModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
